import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/liquidaciones-configuraciones-percepciones';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Liquidaciones Configuraciones Finiquitos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLiquidacionesConfiguracionesFiniquitos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Liquidacion Configuracion Finiquito
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLiquidacionConfiguracionFiniquito = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Liquidacion Configuracion Finiquito
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLiquidacionConfiguracionFiniquito = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Liquidacion Configuracion Finiquito
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLiquidacionConfiguracionFiniquito = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Configuracion Finiquito
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionConfiguracionFiniquito = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Configuracion Finiquito From Percepciones
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionConfiguracionFiniquitoFromPercepciones = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response);
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Liquidaciones Empleados
 * @returns {Promise<object[]>}
 */
export const getLiquidacionesConfiguracionesPercepciones = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * DELETE Liquidacion Configuracion Finiquito
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionConfiguracionPercepcion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Editado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Liquidacion Configuracion Finiquito
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarLiquidacionConfiguracionFiniquito = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/autorizar`);
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * CANCELAR Liquidacion Configuracion Finiquito
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const cancelarLiquidacionConfiguracionFiniquito = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/cancelar`);
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * REACTIVAR Liquidacion Configuracion Finiquito
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const reactivarLiquidacionConfiguracionFiniquito = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/reactivar`);
    onSuccess(response, 'Reactivado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
